import clsx from 'clsx';
import { Anchor, ContentLimiter } from 'components/atoms';
import React from 'react';
import { UnternehmenPlusDto } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';

import css from './Rechtstatsachen.module.scss';

interface RechtstatsachenProps
{
  data: UnternehmenPlusDto['rechtstatsachen'];
}

const Rechtstatsachen: React.FC<RechtstatsachenProps> = (props) =>
{
  const { data } = props;
  const { t } = useTranslation();

  function wrapLinks(text: string)
  {
    const reg = /(.*)\(FN *(\d*) *([a-z])\)(.*)/gm;
    const match = reg.exec(text);
    
    if (!match) return text;

    return (
      <span>
        {match[1]}
        {' '}
        <Anchor href={`/u/${'0'.repeat(6 - match[2].length) + match[2]}${match[3]}`}>
          {`(FN ${match[2]} ${match[3]})`}
        </Anchor>
        {' '}
        {match[4]}
      </span>
    );
  }

  return (
    <table className={clsx('profileTable', css.table)}>
      <thead>
        <tr>
          <th>{t('profiles:unternehmen.rechtstatsachen.date')}</th>
          <th>{t('profiles:unternehmen.rechtstatsachen.text')}</th>
        </tr>
      </thead>
      <tbody>
        <ContentLimiter tableColSpan={2} stepSize={10} initialLimit={3}>
          {[...data].reverse().map((rt) => (
            <tr key={rt.item}>
              <th scope="row">{rt.zeitpunkt}</th>
              <td>{wrapLinks(rt.item)}</td>       
            </tr>
          ))}
        </ContentLimiter>
      </tbody>
    </table>
  );
};

export default Rechtstatsachen;
